module.exports = __webpack_public_path__ + "img/home_environment.81bcfaee.png";